import React from 'react'
import Smartphone from 'components/MainSections/Smartphone/Smartphone'
import Tablet from 'components/MainSections/Tablet/Tablet'
import Browser from 'components/MainSections/Browser/Browser'

export default class MainContent extends React.Component {
  render() {
    return (
      <div className="content main-page">
        <Smartphone />
        <Browser />
        <Tablet />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/MainContent/MainContent.js